import { createRouter, createWebHistory } from "vue-router";
import { routes } from "@/router/routes";
import { scrollBehavior } from "@/router/scrollBehavior";
import { setRouterRef } from "@/router/routerRef";

const router = createRouter({
  history: createWebHistory("/"),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior,
});

setRouterRef(router);

export { router };
